import * as React from "react";
import { KBArticle } from "../types";
import Header from "./Header";
import Button from "./Button";
import MessengerFlexContainer from "./MessengerFlexContainer";

interface KBResultsProps {
  kbArticles: Array<KBArticle>;
  isPopout: boolean;
  onClose: () => void;
  onCollapse: () => void;
  onPopout: () => void;
  onContinueFromKnowledgeBase: () => void;
}

class KBResults extends React.Component<KBResultsProps, {}> {
  render() {
    const articles = this.props.kbArticles || [];
    return (
      <MessengerFlexContainer>
        <Header
          isPopout={this.props.isPopout}
          onCollapse={this.props.onCollapse}
        />
        <div className="velaro-kb-articles">
          <p style={{ textAlign: "center" }}>Knowledge Base Articles</p>
          <ul>
            {articles.map((article) => (
              <li key={article.url}>
                <a href={article.url} target="_blank">
                  {article.name}
                </a>
              </li>
            ))}
          </ul>
          <div className="actions">
            <Button
              variant="primary"
              onClick={() => this.props.onContinueFromKnowledgeBase()}
            >
              Continue
            </Button>
          </div>
        </div>
      </MessengerFlexContainer>
    );
  }
}

export default KBResults;
